import { notification } from 'antd';
import { t } from 'helpers/i18n';
import { debounce } from 'lodash';
import { NOTI_DEBOUNCE_TIME } from '../constants/common';

const handleResponseSuccess = debounce((response: any) => {
  const method: string = response.config.method;

  switch (method) {
    case 'put':
      if (
        response.config.url !== '/ticket/assigns' &&
        response.config.url !== '/ticket/updateMerchantContractMCA' &&
        response.config.url !== '/ticket/additionalSposContract'
      ) {
        let notif = generateNotif(response);
        notification.success(notif);
      }

      break;

    default:
      break;
  }
}, NOTI_DEBOUNCE_TIME);

const generateNotif = (response: any) => {
  let url = response.request.responseURL;
  if (url.search(/\/granted-rules\/[\d]+\/status/) !== -1) {
    return {
      message: t('Notif'),
      description: response?.data?.result
        ? t(response?.data?.result)
        : t('Update Data Success'),
    };
  }

  return {
    message: t('SuccessNotif'),
    description: t('Update Data Success'),
  };
};

export default {
  handleResponseSuccess,
};
